var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"articleWithThumbnail-empty"},[_c('span',{staticClass:"color--black30"},[_vm._v("目前無查核報告")])])])
}]

export { render, staticRenderFns }